import { createContext, useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getSocket } from "../../../socket/socket";

type SocketContextType = {
  socket: ReturnType<typeof getSocket>;
  ready: boolean;
};

const SocketContext = createContext<SocketContextType | null>(null);

// Ne crée le socket que si nécessaire
export const SocketProvider = ({ children }: { children: React.ReactNode }) => {
  const isAuth = useSelector((state: any) => state.auth.isAuthenticated);
  const [ready, setReady] = useState(false);

  const socket = getSocket();

  useEffect(() => {
    if (!isAuth) {
      socket.disconnect();
      setReady(false);
      return;
    }

    if (!socket.connected) {
      socket.connect();
    }

    socket.on("connect", () => setReady(true));
    socket.on("disconnect", () => setReady(false));
    socket.on("connect_error", () => setReady(false));

    return () => {
      socket.off("connect");
      socket.off("disconnect");
      socket.off("connect_error");
    };
  }, [isAuth]);

  return (
    <SocketContext.Provider value={{ socket, ready }}>
      {children}
    </SocketContext.Provider>
  );
};

export const useSocket = () => {
  const context = useContext(SocketContext);

  if (!context) {
    throw new Error("useSocket must be used inside SocketProvider");
  }
  return context;
};
